import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=aff18b54&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=aff18b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff18b54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aff18b54')) {
      api.createRecord('aff18b54', component.options)
    } else {
      api.reload('aff18b54', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=aff18b54&scoped=true&", function () {
      api.rerender('aff18b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zbk7CPKHE1II/JS/comp/DateRange.vue"
export default component.exports